import React from 'react';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';


function useQueryParams({initialParams = {}, isCollectionPage, originalSearchTerm} = {}) {
  const {search} = useLocation();

  return React.useMemo(() => {
    const params = queryString.parse(search);

    if (isCollectionPage && !params?.q) {
      return {
        ...params,
        q: originalSearchTerm || initialParams?.collectionPageKeyword
      }
    }
    return params
  }, [initialParams?.collectionPageKeyword, isCollectionPage, originalSearchTerm, search]);
}

export default useQueryParams;
